//import icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'remixicon/fonts/remixicon.glyph.json';



//import bootstrap
//import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';
import Header from './components/Header';
import SideBar from './components/SideBar';
import Files from './components/Files';
// import AgronomyReports from './components/AgronomyReports';
// import GrowerReg from './components/GrowerReg';
import Main from './components/Main';
import PageTitle from './components/PageTitle'
import {Capture} from "./components/Capture";
// import { Route, Routes} from 'react-router-dom';
import { Component } from 'react';
import AgronomyReports from './components/AgronomyReports';
import LoansDash from './components/LoansDash';
import { LoansReports } from './components/LoansReports';
import { Login } from './components/Login';
import { WarehouseDash } from './components/WarehouseDash';
import { Otherreports } from './components/Otherreports';
import { Gms } from './components/Gms';
import {AgronomyDash} from "./components/AgronomyDash";
import {WarehouseReports} from "./components/WarehouseReports";
import {PayrollDash} from "./components/PayrollDash";
import {PayrollReports} from "./components/PayrollReports";


class App extends Component {

  constructor(){
    super()
    this.state={
      "route":"",
      "ip_address":"",
      "userid":0,
      "ticketsData":[],
      "growerDeliveryData":[],
      "ticketsBatchingData":[],
      "sellingPointsData":[],
      "buyersData":[],
      "startOfDayData":[],
      "deliveryNoteData":[],
      "growerDeliveryNoteData":[],
      "balancingData":[],
      "captureInternalsData":[],
      "chargeTypeData":[],
      "internalStopOrdersData":[],
      "statutoryValueData":[],
      "statutoryData":[]

    }
  }

  componentDidMount(){

    fetch('http://'+window.location.host+'/config.txt')
        .then(response => response.text())
        .then(data => {
          console.log(data,"hellooooooooooooooo")
          this.setState({"ip_address":data})
        });

   // alert(this.state.ip_address)

    console.log(this.state.ip_address+"my ip")

  }

  onclick=()=>{
    this.setState({"route":"hie"})
  }

  homeclick=()=>{

    console.log("pri")
    this.setState({"route":"home"})
  }
  agronomyreportsclick=()=>{
    console.log("pri")
    this.setState({"route":"AgronomyReports"})
  }
  usersclick=()=>{

    console.log("pri")
    this.setState({"route":"ManageUsers"})
  }
  backupclick=()=>{

    console.log("pri")
    this.setState({"route":"Backup"})
  }

  loansreportsclick=()=>{

    console.log("pri")
    this.setState({"route":"LoansReports"})
  }
  loansclick=()=>{

    console.log("pri")
    this.setState({"route":"LoansDash"})
  }

  loginclick=()=>{
    console.log("pri")
    this.setState({"route":"Login"})
  }
  otherreportsclick=()=> {
    console.log("pri")
    this.setState({"route": "Otherreports"})
  }

  gmsclick=()=>{
    console.log("pri")
    this.setState({"route":"Gms"})
  }
  agronomydashclick=()=>{
    console.log("pri")
    this.setState({"route":"AgronomyDash"})
  }
  warehouseclick=()=>{
    console.log("pri")
    this.setState({"route":"WarehouseDash"})
  }
  warereportsclick=()=>{
    console.log("pri")
    this.setState({"route":"WarehouseReports"})
  }
  payrolldashclick=()=>{
    console.log("pri")
    this.setState({"route":"PayrollDash"})
  }
  payrollreportsclick=()=>{
    console.log("pri")
    this.setState({"route":"PayrollReports"})
  }


  render(){

    if(this.state.route===""){


    return (
      <>
      <Header />
      <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
       backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
               agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
               warehouseclick={this.warehouseclick} warereportsclick={this.warereportsclick} payrollreportsclick={this.payrollreportsclick}
      payrolldashclick={this.payrolldashclick} />
      <Main >
        <PageTitle id_address={this.state.ip_address}/>
      </Main>
      {/* <Files /> */}
      </>
   
    
);
    }else if(this.state.route==="home"){

      return (
        <>
        <Header />
        <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
                 backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                 agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
                 warehouseclick={this.warehouseclick} warereportsclick={this.warereportsclick} payrollreportsclick={this.payrollreportsclick}
                 payrolldashclick={this.payrolldashclick}  />
        <Main >
          <PageTitle id_address={this.state.ip_address}/>
        </Main>
        {/* <Files /> */}
        </>
     
      
  );
    }else if(this.state.route==="AgronomyDash"){
      return (
        <>
        <Header />
        <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
                 backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                 agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
                 warereportsclick={this.warereportsclick}  warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                 payrolldashclick={this.payrolldashclick}/>
        <Main >
        <AgronomyDash />
        </Main>
        
        </>
     
      
  );
    }else if (this.state.route==="AgronomyReports") {
    
      return (
        <>
        <Header />
        <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
                 backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                 agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
                 warereportsclick={this.warereportsclick}  warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                 payrolldashclick={this.payrolldashclick}/>
        <Main >
          <AgronomyReports />
        </Main>
        
        </>
     
      
  );
    }else if (this.state.route==="LoansReports") {

      return (
          <>
            <Header />
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
                     backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
                     warereportsclick={this.warereportsclick}  warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main >
              <LoansReports />
            </Main>

          </>


      );
    }else if(this.state.route==="Otherreports") {
      return (
          <>
            <Header />
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
                     backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
                     warereportsclick={this.warereportsclick}  warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              <Otherreports />
            </Main>
          </>
      );
    }else if(this.state.route==="Gms") {
      return (
          <>
            <Header/>
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick} usersclick={this.usersclick}
                     backupclick={this.backupclick}  loginclick={this.loginclick} otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick} loansclick={this.loansclick}
                     warereportsclick={this.warereportsclick}  warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              < Gms />
            </Main>
          </>
      );
    }else if(this.state.route==="LoansDash") {
      return (
          <>
            <Header/>
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick}
                     usersclick={this.usersclick} warereportsclick={this.warereportsclick}
                     backupclick={this.backupclick} loginclick={this.loginclick}
                     otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick}
                     loansclick={this.loansclick} warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              <LoansDash/>
            </Main>
          </>
      );
    }else if(this.state.route==="WarehouseDash") {
      return (
          <>
            <Header/>
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick}
                     usersclick={this.usersclick} warereportsclick={this.warereportsclick}
                     backupclick={this.backupclick} loginclick={this.loginclick}
                     otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick}
                     loansclick={this.loansclick} warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              <WarehouseDash/>
            </Main>
          </>
      );
    }else if(this.state.route==="WarehouseReports") {
      return (
          <>
            <Header/>
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick}
                     usersclick={this.usersclick} warereportsclick={this.warereportsclick}
                     backupclick={this.backupclick} loginclick={this.loginclick}
                     otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick}
                     loansclick={this.loansclick} warehouseclick={this.warehouseclick} payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              <WarehouseReports/>
            </Main>
          </>
      );
    }else if(this.state.route==="PayrollReports") {
      return (
          <>
            <Header/>
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick}
                     usersclick={this.usersclick} warereportsclick={this.warereportsclick}
                     backupclick={this.backupclick} loginclick={this.loginclick}
                     otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick}
                     loansclick={this.loansclick} warehouseclick={this.warehouseclick}
                     payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              <PayrollReports/>
            </Main>
          </>
      );
    }else if(this.state.route==="PayrollDash") {
      return (
          <>
            <Header/>
            <SideBar onclick={this.onclick} homeclick={this.homeclick} agronomyreportsclick={this.agronomyreportsclick}
                     usersclick={this.usersclick} warereportsclick={this.warereportsclick}
                     backupclick={this.backupclick} loginclick={this.loginclick}
                     otherreportsclick={this.otherreportsclick} gmsclick={this.gmsclick}
                     agronomydashclick={this.agronomydashclick} loansreportsclick={this.loansreportsclick}
                     loansclick={this.loansclick} warehouseclick={this.warehouseclick}
                     payrollreportsclick={this.payrollreportsclick}
                     payrolldashclick={this.payrolldashclick}/>
            <Main>
              <PayrollDash/>
            </Main>
          </>
      );
    }
  }
}
  
   

export default App;
